import { ClientUsersType } from '../type/ClientUsers.type';

export const clientUsersInitialize: ClientUsersType = {
    users: [],
}